import { cacheDom } from "../utils/QuerySelectors.js"
import { money } from '../utils/helpers'

const state = {
  json: null,
}
const dom = {}
const qs = {
  section: 'data-section-type="main-product"',
  swiper: 'data-gallery-swiper',
  thumbs: 'data-gallery-thumb-swiper',
  json: 'data-products-json',
  oosBtn: 'data-oos',
  price: 'data-pdp-price',
  optionValue: 'data-option-value',
  showAll: 'data-show-all',
  colorModal: 'data-pdp-colors',
  colorModalMain: 'data-pdp-colors-inner',
  description: 'data-description',
  accordionFeature: 'data-accordion-features',
  accordionMaterial: 'data-accordion-materials',
  accordionShipping: 'data-accordion-shipping',
  accordionFeatureDetail: 'data-pdp-acc-features',
  accordionMaterialDetail: 'data-pdp-acc-materials',
  accordionShippingDetail: 'data-pdp-acc-shipping-returns',
  colorPanelClose: 'data-pdp-colors-close',
  variantSelect: 'data-variant-selector',
  sku: 'data-sku',
  priceWrapper: 'data-pdp-price',
}
const qsAll = {
  slideImages: 'data-slide-image',
  // swatches: 'data-pdp-swatch',
  formBtns: 'data-form-btn',
  colorStyles: 'data-color-style',
  colorPanels: 'data-color-panel',
  paymentForms: 'data-additional-payment',
}

const toggleColorModal = (toggle = true) => {
  dom.colorModal.classList.toggle('z-[-1]', !toggle)
  dom.colorModal.classList.toggle('opacity-0', !toggle)
  dom.colorModal.classList.toggle('z-50', toggle)
  dom.colorModal.classList.toggle('opacity-100', toggle)
  
  dom.colorModalMain.classList.toggle('right-[-31rem]', !toggle)
  dom.colorModalMain.classList.toggle('right-0', toggle)

  document.body.classList.toggle('overflow-hidden', toggle)
}

export const setupProduct = () => {
  cacheDom(dom, qs, qsAll)
  if(dom.section) {
    if(dom.showAll) {
      dom.showAll.addEventListener('click', () => {
        toggleColorModal()
      })
      dom.colorModal.addEventListener('click', () => {
        toggleColorModal(false)
      })
      dom.colorModalMain.addEventListener('click', (e) => {
        e.stopPropagation()
      })
    }
    if(dom.colorPanelClose) {
      dom.colorPanelClose.addEventListener('click', () => {
        toggleColorModal(false)
      })
    }
    dom.colorStyles.forEach((colorStyle) => {
      colorStyle.addEventListener('click', (e) => {
        const colorStyle = e.target.dataset.colorStyle
        dom.colorStyles.forEach((tempStyle) => tempStyle.classList.toggle('opacity-50', tempStyle != e.target))
        dom.colorPanels.forEach((panel) => {
          panel.classList.toggle('grid', colorStyle == panel.dataset.colorPanel)
          panel.classList.toggle('hidden', colorStyle != panel.dataset.colorPanel)
        })
      })
    })
    if(dom.variantSelect) {
      dom.variantSelect.addEventListener('change', (e) => {
        const selectedOption = e.target.querySelector('option:checked')
        const sku = selectedOption ? selectedOption.dataset.variantSku : null
        const price = selectedOption ? selectedOption.dataset.variantPrice : null
        const comparePrice = selectedOption ? selectedOption.dataset.variantComparePrice : null
        dom.sku.innerHTML = `#${sku}`
        dom.priceWrapper.innerHTML = `${money(price)}${comparePrice && parseFloat(comparePrice) > parseFloat(price) ? '<span class="price-compare">' + money(comparePrice) + '</span>' : ''}`
      })
    }
  }
}